import styled from 'styled-components';

import LinkButton from 'src/app/components/Elements/Button/LinkButton';

export const InputContainer = styled.div`
  width: 100%;
`;

export const MedStep = styled.div`
  width: 100%;
  padding-bottom: 4rem;
`;

export const FamilyButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.circular};

  margin-top: ${props => props.theme.space['2.6']} !important;
`;

export const FamilyButton = styled(LinkButton)`
  text-align: left !important;
  padding-top: 0 !important;
  padding-left: 0 !important;
`;
